"use client"

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { CheckCircle, Heart, X } from "lucide-react"

interface GratitudeSuccessProps {
  onClose: () => void
}

export function GratitudeSuccess({
  onClose
}: GratitudeSuccessProps) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <Card className="w-full max-w-md">
        <CardHeader className="pb-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="absolute left-2 top-2 h-8 w-8 p-0"
          >
            <X className="h-4 w-4" />
          </Button>
          <div className="text-center">
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <CheckCircle className="h-8 w-8 text-green-600" />
            </div>
            <CardTitle className="text-xl">הודעת התודה נשלחה בהצלחה!</CardTitle>
          </div>
        </CardHeader>
        
        <CardContent className="space-y-4 text-center pb-6">
          <p className="text-muted-foreground">
            התודה שלך נשלחה בהצלחה ובטח תחמם את הלב 💚
          </p>

          <div className="bg-green-50 p-4 rounded-lg border border-green-200">
            <p className="text-sm font-medium text-green-900 mb-2">
              תודה רבה על ההוקרה!
            </p>
            <p className="text-xs text-green-700">
              המתנדבים שלנו מתנדבים בלב שלם כדי לעזור לישראלים בכל מקום ובכל זמן 🇮🇱
            </p>
          </div>

          <Button
            onClick={onClose}
            className="w-full bg-primary hover:bg-primary/90"
          >
            סגור
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
